var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPlanArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.57143 6.58077H8.28571L6.40571 8.50132C6.35215 8.55559 6.30964 8.62015 6.28063 8.69129C6.25162 8.76242 6.23669 8.83872 6.23669 8.91578C6.23669 8.99285 6.25162 9.06915 6.28063 9.14028C6.30964 9.21142 6.35215 9.27598 6.40571 9.33025C6.51278 9.43897 6.65761 9.5 6.80857 9.5C6.95953 9.5 7.10436 9.43897 7.21143 9.33025L9.66286 6.82011C9.87748 6.60216 9.99872 6.30616 10 5.99701C9.99722 5.6899 9.87609 5.39627 9.66286 5.17976L7.21143 2.66962C7.15815 2.61557 7.09497 2.57278 7.0255 2.54367C6.95603 2.51457 6.88163 2.49973 6.80655 2.5C6.73147 2.50028 6.65717 2.51565 6.58791 2.54525C6.51864 2.57486 6.45576 2.61811 6.40286 2.67254C6.34995 2.72696 6.30806 2.79151 6.27957 2.86247C6.25109 2.93344 6.23656 3.00945 6.23682 3.08615C6.23709 3.16285 6.25214 3.23875 6.28112 3.30951C6.3101 3.38027 6.35243 3.4445 6.40571 3.49855L8.28571 5.41326H2.57143C2.41988 5.41326 2.27453 5.47476 2.16737 5.58424C2.0602 5.69371 2 5.84219 2 5.99701C2 6.15184 2.0602 6.30032 2.16737 6.40979C2.27453 6.51927 2.41988 6.58077 2.57143 6.58077Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlanArrow);
export default __webpack_public_path__ + "static/media/planArrow.f6d38af786ac8a34290ef134d1316109.svg";
export { ForwardRef as ReactComponent };